import { render, staticRenderFns } from "./common_bottom_notlogin.vue?vue&type=template&id=40146970&scoped=true&"
import script from "./common_bottom_notlogin.vue?vue&type=script&lang=js&"
export * from "./common_bottom_notlogin.vue?vue&type=script&lang=js&"
import style0 from "./common_bottom_notlogin.css?vue&type=style&index=0&id=40146970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40146970",
  null
  
)

export default component.exports